import { RoleEnum } from '@enum/role.enum';

export const RoleNames = {
  [RoleEnum.Owner]: 'Owner',
  [RoleEnum.Admin]: 'Admin',
  [RoleEnum.Developer]: 'Developer',
  [RoleEnum.User]: 'Viewer',
};

export const TEAM_ADMIN_ROLES = new Set([RoleEnum.Owner, RoleEnum.Admin]);
